import React, { useEffect } from "react";

export function RootRedirectPage() {
  useEffect(() => {
    window.location.replace("https://vidyagiri.com");
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        margin: 0,
      }}
    />
  );
}
